export const kmToMiles = (km) => Number((km * 0.621371).toFixed(2));
